import { useEventCallback } from 'usehooks-ts'

/**
 * Handles clicking outside of the dialog content. Accounts for scrollbars and floating elements
 *
 * @author Vladyslav Vladinov
 */
export const useOutsideClickHandler = (
	contentRef: React.RefObject<HTMLElement>
) => {
	return useEventCallback((e: CustomEvent<{ originalEvent: PointerEvent }>) => {
		if (!contentRef.current) return

		const currentTarget = e.currentTarget as HTMLElement

		// Prevent clicking on the scrollbars from closing the dialog.
		if (e.detail.originalEvent.offsetX > currentTarget.clientWidth) {
			e.preventDefault()
		}

		const contentRect = contentRef.current.getBoundingClientRect()
		// Detect if click actually happened within the bounds of content.
		// This can happen if click was on an absolutely positioned element overlapping content,
		// such as the 1password extension icon in the text input.
		const actuallyClickedInside =
			e.detail.originalEvent.clientX > contentRect.left &&
			e.detail.originalEvent.clientX < contentRect.left + contentRect.width &&
			e.detail.originalEvent.clientY > contentRect.top &&
			e.detail.originalEvent.clientY < contentRect.top + contentRect.height
		if (actuallyClickedInside) {
			e.preventDefault()
		}
	})
}
